import type { ScheduleMessage } from '../../../types/ScheduleMessage';
import { translate } from '../../common/helpers/translate.helper';
import { FormikPortDetailSelect } from '../../port/portSelect/FormikPortDetailSelect';

interface FormikComparePortSelectProps {
    name: string;
    schedules?: ScheduleMessage[];
    vesselId?: string;
}

export const FormikComparePortSelect = ({ name, schedules = [], vesselId }: FormikComparePortSelectProps) => (
    <FormikPortDetailSelect
        name={name}
        placeholder={translate('compare.placeholder.port')}
        minWidth="0"
        dropdownWidth="400px"
        schedule={schedules
            .filter((schedule) => schedule.port)
            .map((schedule, index) => ({
                ...schedule,
                rank: index + 1,
                timeZoneId: schedule.port!.timeZoneId,
            }))}
        vesselId={vesselId}
    />
);
